{
  "it": {
    "published": {
      "labels": {
        "notPublished": "Non pubblicato",
        "publishedCustomer": "Pubblicato per i clienti",
        "publishedCustomerPartners": "Pubblicato per clienti e partner",
        "publishedPartners": "Pubblicato per i partner"
      },
      "publish_mode": {
        "inherit": "Segui il modello",
        "inherit_info": "Mantiene lo stato pubblicato o non pubblicato di ogni elemento del modello"
      }
    }
  }
}
